import { Platform } from "@angular/cdk/platform";
import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

@Injectable()
export default class RangeDateAdapter extends NativeDateAdapter {
	useUtcForDisplay = true;
	getFirstDayOfWeek(): number {
		return 1;
	}
}
